import { Injectable } from '@angular/core';
import { recentBookingResult } from './Api_Module';

@Injectable()
export class Globals {
  recentBookings: recentBookingResult[] = [];
    constructor() {
    }

}
